var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polyline, _circle, _rect, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1e6ea;}.cls-2{fill:#fff;}.cls-3,.cls-4,.cls-5{fill:none;stroke-linecap:round;stroke-miterlimit:10;}.cls-3{stroke:#3c4650;stroke-width:0.63px;}.cls-4{stroke:#748699;}.cls-4,.cls-5{stroke-width:1.18px;}.cls-5{stroke:#ffaa96;}.cls-6{fill:#f05f2a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphic-device-lock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.72,134.41a5.83,5.83,0,0,0,5.84,5.82H332.14a5.83,5.83,0,0,0,5.84-5.82V39.28a5.83,5.83,0,0,0-5.84-5.82H169.56a5.83,5.83,0,0,0-5.84,5.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.72,131a5.37,5.37,0,0,0,5.41,5.33H326.8a5.37,5.37,0,0,0,5.41-5.33V43.79a5.37,5.37,0,0,0-5.41-5.33H176.13a5.37,5.37,0,0,0-5.41,5.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345,157.93c-1.87-2.13-4.08-4.83-5.25-6.19-2.45-3-4.24-4.29-8.34-4.29H168.11c-4.1,0-5.89,1.28-8.34,4.29-1.17,1.36-3.38,4.07-5.25,6.19s-1.77,4.56,4.2,4.56H340.83C346.8,162.48,346.91,160,345,157.93Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.83,68V38.41a5.87,5.87,0,0,1,5.87-5.87H332.12A5.87,5.87,0,0,1,338,38.41V98.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.42,140.23H168.2a5.37,5.37,0,0,1-5.37-5.37V106.12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M338.78,121.57v12.79a5.87,5.87,0,0,1-5.87,5.87H248.26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M354.64,162.18c-2.55-2.9-5.59-6.61-7.18-8.46-3.36-4.12-5.8-5.87-11.41-5.87H164c-5.6,0-8.05,1.75-11.41,5.88-1.6,1.85-4.63,5.56-7.18,8.46s-2.41,6.24,5.75,6.24H348.89C357.05,168.42,357.19,165.09,354.64,162.18Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M238.26,86.17v2.3c0,.21,0,1.66-1.42,1.66h-1.6c-1.22,0-1.28-1.25-1.28-1.66v-2.3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M272.81,80.35H229.23v9.12c0,1.54.23,6.19,4.79,6.19h3.18c5.3,0,5.32-5.43,5.32-6.19v-3.3h17.56V92.8h-5"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "272.81 86.17 265.86 86.17 265.86 92.8 270.35 92.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 250.41,
    cy: 86.52,
    r: 35.03
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 214.44,
    y: 60.84,
    width: 9.33,
    height: 12.24
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M225.53,57.77l-.05-4.25c0-3.45-.07-6.42-5.19-6.36l-3.75,0c-5.11.05-5.08,3.18-5,6.48l0,4.25-3.21,0,.1,9c.06,5,.11,9.37,7.57,9.28l5.47-.07c7.46-.08,7.41-4.63,7.35-9.45l-.1-9Zm-9.24-5.85,4.36,0,.07,5.95-4.36.05Zm4.51,12.88-.63,1.37.69,4.41-4.36,0,.6-4.31-.66-1.46S216.2,63,218.6,63,220.8,64.79,220.8,64.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceLock);
export default __webpack_public_path__ + "static/media/device-lock.ac63fc16d5c2329993fe93785ee48e8c.svg";
export { ForwardRef as ReactComponent };